import { render, staticRenderFns } from "./subcategory.vue?vue&type=template&id=0ca9af40&scoped=true"
import script from "./subcategory.vue?vue&type=script&lang=js"
export * from "./subcategory.vue?vue&type=script&lang=js"
import style0 from "./subcategory.vue?vue&type=style&index=0&id=0ca9af40&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca9af40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ca9af40')) {
      api.createRecord('0ca9af40', component.options)
    } else {
      api.reload('0ca9af40', component.options)
    }
    module.hot.accept("./subcategory.vue?vue&type=template&id=0ca9af40&scoped=true", function () {
      api.rerender('0ca9af40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/subcategory/subcategory.vue"
export default component.exports